import AccountAdvertiserInfoEdit from 'modules/Services/AccountAdvertiserInfoEdit/AccountAdvertiserInfoEdit'
import Saga from 'modules/Services/AccountAdvertiserInfoEdit/saga'

export { Saga as Sagas }

export default AccountAdvertiserInfoEdit
